/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoFusionModelsBlankReferences,
    SharedserviceMelcoFusionModelsBlankReferencesFromJSON,
    SharedserviceMelcoFusionModelsBlankReferencesToJSON,
    SharedserviceMelcoFusionModelsCreateBlank,
    SharedserviceMelcoFusionModelsCreateBlankFromJSON,
    SharedserviceMelcoFusionModelsCreateBlankToJSON,
    SharedserviceMelcoFusionModelsUpdateBlank,
    SharedserviceMelcoFusionModelsUpdateBlankFromJSON,
    SharedserviceMelcoFusionModelsUpdateBlankToJSON,
    SharedserviceMelcoFusionModelsUserBlank,
    SharedserviceMelcoFusionModelsUserBlankFromJSON,
    SharedserviceMelcoFusionModelsUserBlankToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem,
    SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemToJSON,
} from '../models';

export interface BlanksApiUserBlankCreateRequest {
    sharedserviceMelcoFusionModelsCreateBlank?: SharedserviceMelcoFusionModelsCreateBlank;
}

export interface BlanksApiUserBlankDeleteRequest {
    id: string;
    force?: boolean;
}

export interface BlanksApiUserBlankDuplicateRequest {
    id: string;
}

export interface BlanksApiUserBlankGetDefRequest {
    id: string;
    publishState?: string;
}

export interface BlanksApiUserBlankReferencesRequest {
    id: string;
}

export interface BlanksApiUserBlankSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
}

export interface BlanksApiUserBlankUpdateRequest {
    id: string;
    sharedserviceMelcoFusionModelsUpdateBlank?: SharedserviceMelcoFusionModelsUpdateBlank;
}

/**
 * 
 */
export class BlanksApi extends runtime.BaseAPI {

    /**
     */
    async userBlankCreateRaw(requestParameters: BlanksApiUserBlankCreateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/blanks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoFusionModelsCreateBlankToJSON(requestParameters.sharedserviceMelcoFusionModelsCreateBlank),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankCreate(requestParameters: BlanksApiUserBlankCreateRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankDeleteRaw(requestParameters: BlanksApiUserBlankDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userBlankDelete(requestParameters: BlanksApiUserBlankDeleteRequest): Promise<void> {
        await this.userBlankDeleteRaw(requestParameters);
    }

    /**
     */
    async userBlankDuplicateRaw(requestParameters: BlanksApiUserBlankDuplicateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankDuplicate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}/duplicate`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankDuplicate(requestParameters: BlanksApiUserBlankDuplicateRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankDuplicateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankGetDefRaw(requestParameters: BlanksApiUserBlankGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankGetDef(requestParameters: BlanksApiUserBlankGetDefRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankReferencesRaw(requestParameters: BlanksApiUserBlankReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsBlankReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsBlankReferencesFromJSON(jsonValue));
    }

    /**
     */
    async userBlankReferences(requestParameters: BlanksApiUserBlankReferencesRequest): Promise<SharedserviceMelcoFusionModelsBlankReferences> {
        const response = await this.userBlankReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankSearchRaw(requestParameters: BlanksApiUserBlankSearchRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemFromJSON(jsonValue));
    }

    /**
     */
    async userBlankSearch(requestParameters: BlanksApiUserBlankSearchRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem> {
        const response = await this.userBlankSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankUpdateRaw(requestParameters: BlanksApiUserBlankUpdateRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/blanks/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoFusionModelsUpdateBlankToJSON(requestParameters.sharedserviceMelcoFusionModelsUpdateBlank),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankUpdate(requestParameters: BlanksApiUserBlankUpdateRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankUpdateRaw(requestParameters);
        return await response.value();
    }

}
